import { SofturaTable } from "client/CommonComponents"

const PODetailGrid = (props:any) => {
    const {
      purchaseDetailsItem,
      columns,
      showGrid
    } = props;

    
    return(
            <div className={ purchaseDetailsItem?.length !== 0 ? "softura-table mb-3" : "softura-table paginationNav mb-3"} >
                {showGrid ?
                <SofturaTable
                    data={purchaseDetailsItem ?? []}
                    columns={columns}
                    sort={false}
                    defaultPageSize={10}
                    pageSizes={[10, 20, 50]}
                    globalSearch={false}
                    filter={false}
                 data-attribute="PODetailGrid_Default_Grid" />
                : null}
            </div>
    )
}

export default PODetailGrid